import { z } from 'zod';

import { zodContractVersionPageBaseSchema } from '../validations';

/**
 * Validation schemas for the item changes a contract version recorded.
 */

const zodContractItemChangeSchema = z.object({
  action: z.enum(['added', 'removed', 'modified']),
  // Old and new value per modified field; only present for `modified`.
  changes: z
    .record(
      z.string(),
      z.object({ new: z.json().nullish(), old: z.json().nullish() }),
    )
    .nullish(),
  itemId: z.string(),
  productName: z.string().nullish(),
});

export const zodContractHistoryVersionItemChangesResponseSchema =
  zodContractVersionPageBaseSchema.extend({
    data: z.array(zodContractItemChangeSchema),
  });
